import { Component, ElementRef, ViewChild, Inject, OnInit } from '@angular/core';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { FuseNavigationService } from '../../../core/components/navigation/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../core/services/config.service';
import { fuseAnimations } from '../../../core/animations';
import { NavigationModel } from '../../../navigation.model';
import { MatSnackBar } from '@angular/material';
import { LoginModel } from './Login.model';
import { InfoSesion } from './../Global/InfoSesion.model';
import { md5 } from './../Global/md5';
import { AuthService } from './../Seguridad/auth.service';
import { FormControl } from '@angular/forms';


export interface FormModel {
  captcha?: string;
}


var url = window.location.href;
var condition =  url.indexOf("victimas") == -1 ? true : false;



@Component({
	selector : 'login',
	templateUrl : './login.component.html',
	styleUrls  : [condition ? './login-2.component.scss':'./login-2.component2.scss'],
	animations : fuseAnimations
})


/**
* @author Camilo
* @since  08/11/2017
**/
export class LoginComponent implements OnInit
{

	loginForm: FormGroup;
	loginFormErrors: any;
	navigationModel: NavigationModel;
	public datosLogin:LoginModel;
	public mensaje:string;
	public load:Boolean;
	public  validarCaptcha:Boolean;
	public captcha:string;

	 public formModel: FormModel = {};

	constructor(
		

		private _serviciosGenerales:ServiciosGenerales, 
		private _navegacion:FuseNavigationService, 
		private route: ActivatedRoute,
		private router: Router,
		private fuseConfig: FuseConfigService,
		private formBuilder: FormBuilder,
		private _authService:AuthService,
		public snackBar: MatSnackBar
		){


		this.datosLogin = new LoginModel("", "", "");
		this.fuseConfig.setSettings({
			layout: {
				navigation: 'none',
				toolbar   : 'none',
				footer    : 'none'
			}
		});

		this.loginFormErrors = {
			email   : {},
			password: {},
			empresa : {}
		};

		this.navigationModel = new NavigationModel();
		this._navegacion.setNavigationModel(this.navigationModel);
		this.mensaje = "";
		this.datosLogin = new LoginModel("", "", "");
		//_authService.clearSession();
		this.load = false;

	}

	ngOnInit()
	{
		this.loginForm = this.formBuilder.group({
			email   : ['', [Validators.required, Validators.maxLength(20)]],
			password: ['', [Validators.required, Validators.maxLength(30)]],
			empresa: ['', [Validators.required, Validators.maxLength(20)]]
		});

		this.loginForm.valueChanges.subscribe(() => {
			this.onLoginFormValuesChanged();
		});

	}

	onLoginFormValuesChanged()
	{
		for ( const field in this.loginFormErrors )
		{
			if ( !this.loginFormErrors.hasOwnProperty(field) )
			{
				continue;
			}

			// Clear previous errors
			this.loginFormErrors[field] = {};

			// Get the control
			const control = this.loginForm.get(field);

			if ( control && control.dirty && !control.valid )
			{
				this.loginFormErrors[field] = control.errors;
			}
		}
	}

	login(){
		
		this.mensaje = "";
		this.load = true;
		let dateidsesion: Date = new Date();

	if(this.validarCaptcha){

		this._serviciosGenerales.post('usuario/login/' + Number(dateidsesion).toString(), new LoginModel(this.datosLogin.usuario, this.datosLogin.clave, this.datosLogin.empresa)).subscribe(
			result =>{
				this.load = false;
				if(result.error == true){       
					this.mensaje = result.mensaje;
					if( result.sesion != ""){
						this.router.navigate(['/sesion',this.datosLogin.usuario,this.datosLogin.empresa]);
                        return;
                    }
					
					if( result.cambio != "" && result.cambio != undefined){
						this.router.navigate(['/cambiar',this.datosLogin.usuario,this.datosLogin.empresa]);
                        return;
                    }
					return;
				}

			


				let model: any[];
				let opciones = [];

				for(let x in result.o){
					if(result.o[x].children != undefined){
						opciones.push(result.o[x]);
					}else{
						opciones.push({
							'id'   : result.o[x].id,
							'title': result.o[x].title,
							'type' : result.o[x].type,
							'icon' : result.o[x].icon,
							'url'  : result.o[x].url,
							'crud': {'create':result.o[x].c, 'update':result.o[x].u, 'delete':result.o[x].d}
						});	
					}
					
				}

				model = [
				{
					'id'      : 'applications',
					'title'   : 'Empresa: '+this.datosLogin.empresa.toUpperCase(),
					'type'    : 'group',
					'children': []
				},
				{
					'id'      : 'applications',
					'title'   : 'Opciones',
					'type'    : 'group',
					'children': opciones
				}
				];
				
				
				
				this.navigationModel.model = model;
				this._navegacion.setNavigationModel(this.navigationModel);
				let infoSesion:InfoSesion = new InfoSesion(this.navigationModel, result.t, result.c, result.u);
				sessionStorage.setItem('idsesion', Number(dateidsesion).toString());
				sessionStorage.setItem('info', JSON.stringify(infoSesion));
				this.router.navigate(['/dashboard']);
				
				
			},
			error =>{
				var errorMensaje = <any>error;
				this.mensaje = "No se pudo establecer conexión con el servidor";
				this.load = false;
			} )
		}
		else{
			this.mensaje = "Error al validar el Captcha";
			this.load = false;
		}
	}

	

	resolved(captchaResponse: string) {
		
	var  responseCaptcha =`${captchaResponse}`;

	this._serviciosGenerales.post('usuario/validar', new LoginModel(this.datosLogin.usuario, responseCaptcha, this.datosLogin.empresa)).subscribe(
			result =>{
				this.load = false;
				if(result.error == false){
					this.mensaje = result.mensaje;
					this.load = true;
					return;
				}		
				else{
					this.validarCaptcha= true;
				}		

			},
			error =>{
				var errorMensaje = <any>error;
				this.mensaje = "No se pudo establecer conexión con el servidor";
				this.load = false;
			} )
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Login/Login.component.ts